import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { FilesUploadsService } from './services/files-uploads.service';
import { NgButtonComponent } from '@fc-shared/ui/buttons/ng-button';
import { ProgressBarComponent } from './components/progress-bar.component';
import { FilesUploadCardComponent } from './components/files-upload-block.component';
import { FilesUploadUiStore } from './store/files-upload-ui.store';

@Component({
  selector: 'fc-files-upload',
  template: `
    <div
      class="flex flex-col gap-4 shadow-lg rounded-xl bg-white p-16 w-full md:w-420"
    >
      <div class="flex flex-row justify-between gap-12 items-center">
        <div class="text-lg text-grey-900 font-medium">Uploading files</div>

        <div class="flex flex-row gap-12 items-center">
          <span class="text-base text-grey-500 font-medium"
            >{{ filesUploadsService.totalProgress() }}%</span
          >

          <ng-button
            variant="outline"
            (click)="showList.set(!showList())"
            [iconOnly]="true"
            [icon]="showList() ? 'icon-arrow-drop-down' : 'icon-arrow-drop-up'"
          />

          <ng-button
            variant="outline"
            (click)="filesUploadUiStore.hideUploads()"
            [iconOnly]="true"
            icon="icon-close"
          />
        </div>
      </div>

      <div class="flex flex-row text-sm mt-12">
        <span class="font-bold text-grey-900"
          >{{ filesUploadsService.uploads().length }} files
          <span class="text-grey-500 font-medium">
            / {{ filesUploadsService.uploadedSize() }} of
            {{ filesUploadsService.totalSize() }}</span
          ></span
        >
      </div>

      <fc-progress-bar
        [progress]="filesUploadsService.totalProgress()"
      ></fc-progress-bar>
      <div
        class="fc-collapse fc-collapse-fade mt-16"
        [class.fc-collapse-open]="showList()"
        animate.enter="fc-anim-expand"
      >
        <div class="flex flex-col gap-12 max-h-380 overflow-y-auto">
          @for (
            fileUploadState of filesUploadsService.uploads();
            track fileUploadState.id
          ) {
            <fc-files-upload-card
              [fileUploadState]="fileUploadState"
            ></fc-files-upload-card>
          }
        </div>
      </div>
    </div>
  `,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgButtonComponent, ProgressBarComponent, FilesUploadCardComponent],
})
export class FilesUploadComponent {
  readonly filesUploadUiStore = inject(FilesUploadUiStore);
  readonly filesUploadsService = inject(FilesUploadsService);

  showList = signal<boolean>(true);
}
